import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Close = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.40355 3.69645C4.20829 3.50118 3.89171 3.50118 3.69645 3.69645C3.50118 3.89171 3.50118 4.20829 3.69645 4.40355L7.2951 8.00221L3.6965 11.6008C3.50124 11.7961 3.50124 12.1126 3.6965 12.3079C3.89176 12.5032 4.20835 12.5032 4.40361 12.3079L8.00221 8.70931L11.6008 12.3079C11.7961 12.5032 12.1126 12.5032 12.3079 12.3079C12.5032 12.1126 12.5032 11.7961 12.3079 11.6008L8.70931 8.00221L12.308 4.40355C12.5032 4.20829 12.5032 3.89171 12.308 3.69645C12.1127 3.50118 11.7961 3.50118 11.6009 3.69645L8.00221 7.2951L4.40355 3.69645Z"
        fill={color}
      />
    </svg>
  )
})

export default Close
